import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-medge",
  "use": "icon-medge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-medge\"><path d=\"M719.88 151.94L927.77 512 719.88 872.06H304.12L96.23 512l207.89-360.06h415.76m23.1-40H281L50.05 512 281 912.06h462L974 512 743 111.94z\" p-id=\"18854\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol